import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import ReviewsSection from "../components/ReviewsSection";
import "../css/About.css";
import "../css/global.css";
import Slideshow from "../components/Slideshow";
import { useContacts } from "../context/ContactsContext";
import API from "../config/api";
import reviews from "../data/reviews";

// Icon paths from public/assets
const facebookIconSrc = "/assets/icons/facebook.svg";
const mailIconSrc = "/assets/icons/mail.svg";

const About = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [imagesLoading, setImagesLoading] = useState(true);
  const { contacts } = useContacts();

  // Fetch gallery images from PHP backend
  useEffect(() => {
    const fetchImages = async () => {
      setImagesLoading(true);
      try {
        const response = await fetch(API.ENDPOINTS.IMAGES('gallery'));
        const data = await response.json();
        if (data.success && data.images) {
          setGalleryImages(data.images.map(img => `${API.ASSETS_URL}${img}`));
        }
      } catch (error) {
        // Silently handle fetch errors
      }
      setImagesLoading(false);
    };

    fetchImages();
  }, []);

  return (
    <div className="about-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="about-hero-compact">
        <div className="about-hero-content-compact">
          <span className="section-subtitle">LA NOSTRA STORIA</span>
          <h1 className="about-hero-title-compact">Chi Siamo</h1>
          <p className="about-hero-slogan-compact">
            Dal 1967, esperienza e passione nel settore dei serramenti
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="about-content-section">
        <div className="section-content">
          <div className="chisiamo-content">
          <div className="chisiamo-text">
            <span className="section-subtitle">CHI SIAMO</span>
            <h2 className="section-title">La Nostra Storia</h2>
            <p>
              Dal 1967 la ditta <strong>FER-AL</strong> opera nel campo dei
              serramenti in alluminio e ferro e dal 2001 anche nel campo del PVC
              e del legno.
            </p>
            <p>
              L'esperienza nel settore, la scelta dei materiali, la cura dei
              particolari ed un attento controllo della qualità, rendono i
              prodotti creati da FER-AL particolarmente indicati per qualsiasi
              uso, specialmente nell'edilizia privata.
            </p>

            <span className="section-subtitle">PERCHÉ SCEGLIERCI</span>
            <h2 className="section-title">Perché Scegliere FER-AL</h2>
            <p>
              Preferire un prodotto FER-AL significa, oggi, acquistare{" "}
              <strong>qualità</strong>, <strong>affidabilità</strong>,{" "}
              <strong>durata</strong> e <strong>assistenza</strong>.
            </p>
            <p>
              I nostri tecnici Vi sapranno consigliare nella scelta dei
              materiali più adatti alle Vostre esigenze e saranno a Vostra
              disposizione per qualsiasi consulenza, sopralluogo e richiesta di
              preventivo.{" "}
              <em>
                Naturalmente <b>gratuito</b>.
              </em>
            </p>

            <div className="highlight-box">
              <p>
                <strong>Possibilità di pagamenti rateali.</strong>
              </p>
              <p>
                <strong>Si eseguono anche riparazioni.</strong>
              </p>
            </div>

            {/* Scheda: I nostri social */}
            <div className="social-card" aria-labelledby="social-card-title">
              <h3 id="social-card-title">I nostri social</h3>
              <p>
                Seguici sui nostri canali per aggiornamenti, offerte e novità.
              </p>
              <div className="social-icons">
                <a
                  href={contacts.FACEBOOK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Pagina Facebook di Fer-Al"
                  className="social-link"
                >
                  <img
                    src={facebookIconSrc}
                    width={24}
                    height={24}
                    alt=""
                    aria-hidden="true"
                  />
                </a>

                <a
                  href={contacts.MAILTO}
                  aria-label="Invia una email a Fer-Al"
                  className="social-link"
                >
                  <img
                    src={mailIconSrc}
                    width={24}
                    height={24}
                    alt=""
                    aria-hidden="true"
                  />
                </a>
              </div>
            </div>

            {/* Riquadro Orari di Apertura: aggiunto per pareggiare il riquadro a destra */}
            <div
              className="opening-hours"
              aria-labelledby="opening-hours-title"
            >
              <h3 id="opening-hours-title">Orari di Apertura</h3>
              <ul className="hours-list">
                <li>
                  <strong>Lunedì - Venerdì:</strong> 08–12:30, 15–18
                </li>
                <li>
                  <strong>Sabato:</strong> Chiuso
                </li>
                <li>
                  <strong>Domenica:</strong> Chiuso
                </li>
                </ul>
            </div>
                <div className="hours-note">
                  Disponibilità di apertura in altri orari su appuntamento.
                </div>
          </div>

          <div className="chisiamo-slideshow">
            <Slideshow images={galleryImages} loading={imagesLoading} />

            <div className="dove-trovarci">
              <span className="section-subtitle">DOVE SIAMO</span>
              <h2 className="section-title">Dove trovarci</h2>
              <p>
                Vieni a trovarci nel nostro negozio a Firenze. Siamo pronti ad
                accoglierti e a fornirti tutta l'assistenza di cui hai bisogno.
              </p>
              <div className="map-container">
                <iframe
                  title="Mappa FER-AL"
                  src={contacts.MAP_EMBED_URL}
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <p className="address-text">
                <a
                  href={contacts.MAP_SHORT_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                >
                  <strong>{contacts.ADDRESS_LINE}</strong>
                  <br />
                </a>
                (accanto al 108)
                <br />
                {contacts.ADDRESS_CITY}
              </p>
            </div>
          </div>
        </div>
        </div>
      </section>

      {/* Reviews Section */}
      <ReviewsSection reviews={reviews} variant="compact" />
    </div>
  );
};

export default About;
